(ns manage.video-rendering.db
  (:require [manage.video-rendering.queries :as queries]
            [re-frame.core :as rf]))

;; Subscriptions

(rf/reg-sub
  ::render-jobs
  (fn [db]
    (get-in db [:video-rendering :jobs])))

(rf/reg-sub
  ::selected-job
  (fn [db]
    (get-in db [:video-rendering :selected-job])))

(rf/reg-sub
  ::templates
  (fn [db]
    (get-in db [:video-rendering :templates])))

(rf/reg-sub
  ::selected-template
  (fn [db]
    (get-in db [:video-rendering :selected-template])))

(rf/reg-sub
  ::render-profiles
  (fn [db]
    (get-in db [:video-rendering :render-profiles])))

(rf/reg-sub
  ::loading?
  (fn [db]
    (get-in db [:video-rendering :loading?] false)))

(rf/reg-sub
  ::error
  (fn [db]
    (get-in db [:video-rendering :error])))

(rf/reg-sub
  ::render-jobs-cursor
  (fn [db]
    (get-in db [:video-rendering :render-jobs-cursor])))

(rf/reg-sub
  ::render-jobs-history
  (fn [db]
    (get-in db [:video-rendering :render-jobs-history] [])))

(rf/reg-sub
  ::templates-page
  (fn [db]
    (get-in db [:video-rendering :templates-page] 1)))

(rf/reg-sub
  ::templates-pagesize
  (fn [db]
    (get-in db [:video-rendering :templates-pagesize] 20)))

(rf/reg-sub
  ::templates-total-pages
  (fn [db]
    (get-in db [:video-rendering :templates-total-pages])))

;; Events

(rf/reg-event-db
  ::set-loading
  (fn [db [_ loading?]]
    (assoc-in db [:video-rendering :loading?] loading?)))

(rf/reg-event-db
  ::set-error
  (fn [db [_ error]]
    (assoc-in db [:video-rendering :error] error)))

(rf/reg-event-db
  ::clear-error
  (fn [db _]
    (assoc-in db [:video-rendering :error] nil)))

(rf/reg-event-fx
  ::fetch-render-jobs
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    {:dispatch [::set-loading true]
     :http {:method :get
            :uri (queries/get-render-jobs-url url-context advertiser-id)
            :headers {"Authorization" token}
            :on-success [::fetch-render-jobs-success]
            :on-failure [::fetch-render-jobs-failure]}}))

(rf/reg-event-fx
  ::fetch-render-jobs-success
  (fn [{:keys [db]} [_ response]]
    {:db (-> db
             (assoc-in [:video-rendering :jobs] (:jobs response))
             (assoc-in [:video-rendering :render-jobs-cursor] (get-in response [:meta :cursor]))
             (assoc-in [:video-rendering :loading?] false))
     :dispatch [::clear-error]}))

(rf/reg-event-fx
  ::fetch-render-jobs-failure
  (fn [{:keys [db]} [_ error]]
    {:db (assoc-in db [:video-rendering :loading?] false)
     :dispatch [::set-error "Failed to load render jobs"]}))

(rf/reg-event-fx
  ::fetch-templates
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    {:dispatch [::set-loading true]
     :http {:method :get
            :uri (queries/get-templates-url url-context advertiser-id)
            :headers {"Authorization" token}
            :on-success [::fetch-templates-success]
            :on-failure [::fetch-templates-failure]}}))

(rf/reg-event-fx
  ::fetch-templates-success
  (fn [{:keys [db]} [_ response]]
    (let [templates (vec (for [t (:data response)
                               r (:revisions t)
                               :when (= (:template-type r) "after-effects")]
                           (assoc r :name (:name t))))
          meta (:meta response)]
      {:db (-> db
               (assoc-in [:video-rendering :templates] templates)
               (assoc-in [:video-rendering :templates-page] (get meta :page 1))
               (assoc-in [:video-rendering :templates-total-pages] (get meta :total-pages 1))
               (assoc-in [:video-rendering :loading?] false))
       :dispatch [::clear-error]})))

(rf/reg-event-fx
  ::fetch-templates-failure
  (fn [{:keys [db]} [_ error]]
    {:db (assoc-in db [:video-rendering :loading?] false)
     :dispatch [::set-error "Failed to load templates"]}))

(rf/reg-event-fx
  ::fetch-render-profiles
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} _]
    {:http {:method :get
            :uri (queries/get-render-profiles-url url-context)
            :headers {"Authorization" token}
            :on-success [::fetch-render-profiles-success]
            :on-failure [::fetch-render-profiles-failure]}}))

(rf/reg-event-db
  ::fetch-render-profiles-success
  (fn [db [_ response]]
    (assoc-in db [:video-rendering :render-profiles] (:render-profiles response))))

(rf/reg-event-fx
  ::fetch-render-profiles-failure
  (fn [_ [_ error]]
    {:dispatch [:common.notifications/show {:type :error
                                            :message "Failed to load render profiles"}]}))

(rf/reg-event-db
  ::select-template
  (fn [db [_ template]]
    (assoc-in db [:video-rendering :selected-template] template)))

(rf/reg-event-db
  ::close-dialog
  (fn [db _]
    (assoc-in db [:video-rendering :selected-template] nil)))

(rf/reg-event-fx
  ::submit-render-job
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id template content profile]]
    (let [job-data {:advertiser-id advertiser-id
                    :template-id (:template-id template)
                    :template-revision-id (:id template)
                    :content content
                    :profile profile}]
      {:db (-> db
               (assoc-in [:video-rendering :loading?] true)
               (assoc-in [:video-rendering :selected-template] nil)
               (assoc-in [:video-rendering :current-advertiser-id] advertiser-id))
       :http {:method :post
              :uri (queries/create-render-job-url url-context)
              :headers {"Authorization" token}
              :params job-data
              :on-success [::create-render-job-success]
              :on-failure [::create-render-job-failure]}})))

(rf/reg-event-fx
  ::create-render-job
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ job-data]]
    {:dispatch [::set-loading true]
     :http {:method :post
            :uri (queries/create-render-job-url url-context)
            :headers {"Authorization" token}
            :params job-data
            :on-success [::create-render-job-success]
            :on-failure [::create-render-job-failure]}}))

(rf/reg-event-fx
  ::create-render-job-success
  (fn [{:keys [db]} [_ response]]
    (let [advertiser-id (get-in db [:video-rendering :current-advertiser-id])]
      {:db (assoc-in db [:video-rendering :loading?] false)
       :dispatch-n [[::clear-error]
                    [::fetch-render-jobs advertiser-id]
                    [:common.notifications/show {:type :success
                                                 :message "Render job created successfully"}]]})))

(rf/reg-event-fx
  ::create-render-job-failure
  (fn [{:keys [db]} [_ error]]
    {:db (assoc-in db [:video-rendering :loading?] false)
     :dispatch-n [[::set-error "Failed to create render job"]
                  [:common.notifications/show {:type :error
                                               :message "Failed to create render job"}]]}))

(rf/reg-event-fx
  ::cancel-render-job
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ job-id]]
    {:http {:method :delete
            :uri (queries/cancel-render-job-url url-context job-id)
            :headers {"Authorization" token}
            :on-success [::cancel-render-job-success job-id]
            :on-failure [::cancel-render-job-failure]}}))

(rf/reg-event-fx
  ::cancel-render-job-success
  (fn [{:keys [db]} [_ job-id response]]
    {:dispatch-n [[::fetch-render-jobs (get-in db [:router/path-params :advertiser-id])]
                  [:common.notifications/show {:type :success
                                               :message "Render job cancelled"}]]}))

(rf/reg-event-fx
  ::cancel-render-job-failure
  (fn [_ [_ error]]
    {:dispatch [:common.notifications/show {:type :error
                                            :message "Failed to cancel render job"}]}))

(rf/reg-event-fx
  ::poll-job-status
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ job-id]]
    {:http {:method :get
            :uri (queries/get-render-job-url url-context job-id)
            :headers {"Authorization" token}
            :on-success [::poll-job-status-success]
            :on-failure [::poll-job-status-failure]}}))

(rf/reg-event-fx
  ::poll-job-status-success
  (fn [{:keys [db]} [_ response]]
    (let [job (:job response)
          jobs (get-in db [:video-rendering :jobs])
          updated-jobs (mapv #(if (= (:id %) (:id job)) job %) jobs)]
      {:db (assoc-in db [:video-rendering :jobs] updated-jobs)})))

(rf/reg-event-fx
  ::poll-job-status-failure
  (fn [_ [_ error]]
    {}))

(rf/reg-event-fx
  ::fetch-render-jobs-next
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    (let [current-cursor (get-in db [:video-rendering :render-jobs-cursor])
          history (get-in db [:video-rendering :render-jobs-history] [])
          new-history (conj history current-cursor)]
      {:dispatch [::set-loading true]
       :db (assoc-in db [:video-rendering :render-jobs-history] new-history)
       :http {:method :get
              :uri (queries/get-render-jobs-url url-context advertiser-id
                                                (when current-cursor {:after current-cursor}))
              :headers {"Authorization" token}
              :on-success [::fetch-render-jobs-success]
              :on-failure [::fetch-render-jobs-failure]}})))

(rf/reg-event-fx
  ::fetch-render-jobs-prev
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    (let [history (get-in db [:video-rendering :render-jobs-history] [])
          new-history (pop history)
          fetch-cursor (peek new-history)]
      {:dispatch [::set-loading true]
       :db (assoc-in db [:video-rendering :render-jobs-history] new-history)
       :http {:method :get
              :uri (queries/get-render-jobs-url url-context advertiser-id
                                                (when fetch-cursor {:after fetch-cursor}))
              :headers {"Authorization" token}
              :on-success [::fetch-render-jobs-success]
              :on-failure [::fetch-render-jobs-failure]}})))

(rf/reg-event-fx
  ::fetch-render-jobs-first
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    {:dispatch [::set-loading true]
     :db (assoc-in db [:video-rendering :render-jobs-history] [])
     :http {:method :get
            :uri (queries/get-render-jobs-url url-context advertiser-id)
            :headers {"Authorization" token}
            :on-success [::fetch-render-jobs-success]
            :on-failure [::fetch-render-jobs-failure]}}))

(rf/reg-event-fx
  ::fetch-templates-next
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    (let [current-page (get-in db [:video-rendering :templates-page] 1)
          total-pages (get-in db [:video-rendering :templates-total-pages] 1)
          next-page (min (inc current-page) total-pages)]
      {:dispatch [::set-loading true]
       :http {:method :get
              :uri (queries/get-templates-url url-context advertiser-id {:page next-page})
              :headers {"Authorization" token}
              :on-success [::fetch-templates-success]
              :on-failure [::fetch-templates-failure]}})))

(rf/reg-event-fx
  ::fetch-templates-prev
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    (let [current-page (get-in db [:video-rendering :templates-page] 1)
          prev-page (max (dec current-page) 1)]
      {:dispatch [::set-loading true]
       :http {:method :get
              :uri (queries/get-templates-url url-context advertiser-id {:page prev-page})
              :headers {"Authorization" token}
              :on-success [::fetch-templates-success]
              :on-failure [::fetch-templates-failure]}})))

(rf/reg-event-fx
  ::fetch-templates-first
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db :resource.user/token url-context]} [_ advertiser-id]]
    {:dispatch [::set-loading true]
     :http {:method :get
            :uri (queries/get-templates-url url-context advertiser-id {:page 1})
            :headers {"Authorization" token}
            :on-success [::fetch-templates-success]
            :on-failure [::fetch-templates-failure]}}))
